import * as Sentry from "@sentry/react";
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import { LawAuthProvider } from './features/auth/LawAuthProvider'
import './index.css'

// Initialize Sentry for error tracking
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: import.meta.env.MODE, // 'development' or 'production'
        release: `jurimaroc-frontend@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,

        // Performance monitoring
        tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,

        // Session replay for debugging
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,

        // Don't send errors in development unless explicitly enabled
        enabled: import.meta.env.MODE === 'production' || import.meta.env.VITE_SENTRY_ENABLED === 'true',

        // Filter out common non-actionable errors
        beforeSend(event) {
            // Don't send cancelled requests
            if (event.exception?.values?.[0]?.value?.includes('AbortError')) {
                return null;
            }
            return event;
        },
    });
}

ReactDOM.createRoot(document.getElementById('app')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
                <LawAuthProvider>
                    <App />
                </LawAuthProvider>
            </Sentry.ErrorBoundary>
        </BrowserRouter>
    </React.StrictMode>,
)

// Error fallback component
function ErrorFallback() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center p-8">
                <h1 className="text-2xl font-bold text-gray-800 mb-4">
                    Une erreur s'est produite
                </h1>
                <p className="text-gray-600 mb-4">
                    Nous avons été notifiés et travaillons à résoudre le problème.
                </p>
                <button
                    onClick={() => window.location.reload()}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                    Recharger la page
                </button>
            </div>
        </div>
    );
}
